module.exports = __webpack_public_path__ + "media/images/flags/ss-da7ce6fa45782c29f39f265c19972374.svg";